import { render, staticRenderFns } from "./subjectResult.vue?vue&type=template&id=9227a2e0&scoped=true&"
import script from "./subjectResult.vue?vue&type=script&lang=js&"
export * from "./subjectResult.vue?vue&type=script&lang=js&"
import style0 from "./subjectResult.vue?vue&type=style&index=0&id=9227a2e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9227a2e0",
  null
  
)

export default component.exports